import {GAMES_SOUND_TYPE} from "../../games.config";

export const PIG_SOUND_TYPE = {
  win: {
    name: 'win',
    src: GAMES_SOUND_TYPE.win.src
  }
}
